import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'tooltip.text': {
    id: 'tooltip.text',
    defaultMessage: 'A 501c3 is a nonprofit organization that has been recognized by the United States of America IRS as being tax-exempt by virtue of its charitable programs.',
    description: 'Tooltip text',
  },
});
export default messages;
